import type { GlobalState, TabArgs, TabState } from '../types';

import { getCurrentTabId } from '../../util/establishMultitabRole';
import { INITIAL_TAB_STATE } from '../initialState';

export function updateTabState<T extends GlobalState>(
  global: T,
  tabStatePartial: Partial<TabState>,
  ...[tabId = getCurrentTabId()]: TabArgs<T>
): T {
  return {
    ...global,
    byTabId: {
      ...global.byTabId,
      [tabId]: {
        // A patch aimed at a tab with no entry yet (e.g. a stale tab id arriving over the multitab
        // broadcast) must not create a stub missing required fields like `messageLists` — selectors
        // reading such a stub crash the app
        ...(global.byTabId[tabId] || { ...INITIAL_TAB_STATE, id: tabId }),
        ...tabStatePartial,
      },
    },
  };
}
